import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import InvoicePdf from './InvoicePdf';

const InvoicePdfButton = ({ data }) => {
  return (
    <PDFDownloadLink document={<InvoicePdf data={data} />} fileName={`invoice-${data.id || 'new'}-${new Date().toISOString().split('T')[0]}.pdf`}>
      {({ blob, url, loading, error }) =>
        loading ? 'Loading document...' : <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-md shadow">Download PDF</button>
      }
    </PDFDownloadLink>
  );
};

export default InvoicePdfButton;
